import { EntityTaxVM } from './../../models/entity';
import { TokenService } from './../token/token.service';
import { BaseHttpService } from './base.http.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AccountVM } from '../../models/account';
import { IUserAddress } from '../../models/userAddress';
import { AppConfig } from 'src/app/app.config';
import { IEnvironmentConfig } from 'src/app/models/environmentConfig';

@Injectable()
export class UserService extends BaseHttpService {
    constructor(private http: HttpClient, private tokenservice: TokenService, private appConfig: AppConfig) {
        super();
    }

    get envSettings(): IEnvironmentConfig {
        return this.appConfig.getEnvironmentConfig();
    }

    public getUserProfile() {
        const url = this.envSettings.webApiUrl + 'user/current/profile';
        return this.http.get(url, {
            observe: "body",
            responseType: "json",
            headers: this.getHttpHeaders()
        });
    }

    public updateUserProfile(body: AccountVM) {
        const jsonBody = JSON.stringify(body);
        const url = `${this.envSettings.webApiUrl}user/current/profile`;
        return this.http.post(url, jsonBody, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public getTaxStatus() {
        const url = `${this.envSettings.webApiUrl}user/current/entityTax`;
        return this.http.get(url, {
            observe: "body",
            responseType: "json",
            headers: this.getHttpHeaders()
        });
    }

    public getUserRequiredToSetTwoFactorAuthentication() {
        const url = `${this.envSettings.webApiUrl}user/current/requireTwoFactorSet`;
        return this.http.get(url, {
            observe: "body",
            responseType: "json",
            headers: this.getHttpHeaders()
        });
    }

    public setTaxStatus(body: EntityTaxVM) {
        const jsonBody = JSON.stringify(body);
        const url = `${this.envSettings.webApiUrl}user/current/entityTax`;

        return this.http.post(url, jsonBody, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public getAddress(userId: string): Observable<any> {
        const url = `${this.envSettings.webApiUrl}user/${userId}/profile/address`;
        return this.http.get(url, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public setAddress(userId: string, body: IUserAddress) {
        const jsonBody = JSON.stringify(body);
        const url = `${this.envSettings.webApiUrl}user/${userId}/profile/address`;

        return this.http.post(url, jsonBody, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public requestSMSVerification(userEntityId: string, body: string) {
        const jsonBody = JSON.stringify(body);
        const url = `${this.envSettings.webApiUrl}user/${userEntityId}/requestSmsVerification/`;
        return this.http.post(url, jsonBody, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public verifySMS(userProfile: AccountVM, body: string) {
        const userEntityId = userProfile.userEntityId;
        const mobile = userProfile.mobilePhone;
        const jsonBody = JSON.stringify(body);
        const url = `${this.envSettings.webApiUrl}user/${userEntityId}/verifySms/?mobile=${mobile}`;
        return this.http.post(url, jsonBody, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public getUserInvitations(){
        const url = `${this.envSettings.webApiUrl}user/current/invites`;
        return this.http.get(url, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public rejectUserInvitation(invitationId : number) {
        const url = `${this.envSettings.webApiUrl}user/current/invites/${invitationId}/reject`;
        return this.http.post(url, {}, {
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public acceptUserInvitation(invitationId: number) {
        const url = `${this.envSettings.webApiUrl}user/current/invites/${invitationId}/accept`;
        var response = this.http.post(url, {}, {
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
        return response;
    }
}